/**
 * @generated SignedSource<<ad689b66efbc4bbca92a45f9993d6527>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UnsplashTrackDownloadInput = {
  downloadUrl: string;
  organizationId: string;
  productId?: string | null;
};
export type UnsplashSearch_TrackDownloadMutation$variables = {
  input: UnsplashTrackDownloadInput;
};
export type UnsplashSearch_TrackDownloadMutation$data = {
  readonly trackUnsplashDownload: {
    readonly data: boolean | null;
  };
};
export type UnsplashSearch_TrackDownloadMutation = {
  response: UnsplashSearch_TrackDownloadMutation$data;
  variables: UnsplashSearch_TrackDownloadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UnsplashTrackDownloadResponse",
    "kind": "LinkedField",
    "name": "trackUnsplashDownload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "data",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UnsplashSearch_TrackDownloadMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UnsplashSearch_TrackDownloadMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d6f9fff7fcfe8ed0a5cc6fe554d2ea7f",
    "id": null,
    "metadata": {},
    "name": "UnsplashSearch_TrackDownloadMutation",
    "operationKind": "mutation",
    "text": "mutation UnsplashSearch_TrackDownloadMutation(\n  $input: UnsplashTrackDownloadInput!\n) {\n  trackUnsplashDownload(input: $input) {\n    data\n  }\n}\n"
  }
};
})();

(node as any).hash = "1420390b664ebfc32eb1d33e9a8068bb";

export default node;
